import { FieldValues, useController, useFormContext } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { TaxNumberInput } from './TaxNumberInput';

export function TaxNumberField<TValues extends FieldValues>({
  name,
}: FieldProps<TValues>) {
  const { control } = useFormContext<TValues>();
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
  });
  return <TaxNumberInput value={value as string} onChange={onChange} />;
}
